<template>
    <div class="user-story-container">
        <epic-list></epic-list>
    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex'
    import EpicList from 'components/epics/EpicList.vue'
    import { filter } from 'lodash'
    
    export default {
        components: {
            EpicList
        },

        data: function () {
            return {
            }
        },

        created() {
            this.getTagsList()
        },

        mounted() {
            this.getUserStoryDocument(this.project.user_story_document_id)
        },

        computed: {
            ...mapState('yodizproject', {
                project: 'single'
            }),
            ...mapState('epics', ['epics']),

            missingEstimates() {
                var epics = this.epics
                var missingEstimate = 0

                epics.forEach((epic) => {
                    var stories = filter(epic.stories, (story) => {
                        return story.estimate == undefined
                    })

                    missingEstimate += stories.length
                })
                
                return missingEstimate
            },

            zeroEstimates() {
                var epics = this.epics
                var zeroEstimate = 0

                epics.forEach((epic) => {
                    var stories = filter(epic.stories, (story) => {
                        return story.estimate == 0
                    })

                    zeroEstimate += stories.length
                })
                
                return zeroEstimate
            }
        },

        watch: {

        },

        methods: {
            ...mapActions('userStoryDocument', ['getUserStoryDocument']),
            ...mapActions('tags', ['getTagsList'])
        }
    }
</script>
